<template>
  <div>
    <template v-if="routeMatchesComponent()">
      <!-- TODO Improves -->
      <div class="m3 p3 white-bg">
        <div>
          <div class="col-12 flex flex-column items-center justify-center">
            <div class="col-12 sm-col-6 md-col-4 my1 flex items-center justify-center">
              <UserPhoto style="width: 125px; height: 125px; min-width: 125px; min-height: 125px;" />
            </div>
            <div class="col-12 my1 flex items-center justify-center">
              <div class="flex flex-column my-profile-text">
                <div class="">
                  <p class="center h3n bold profile-name blue m0">{{ user.firstname }} {{ user.lastname }}</p>
                  <p class="center h4n semi-bold profile-name blue m0">{{ genderVocabulary(user.gender) }}  le {{ user.birth_date }}</p>
                  <p class="center h5n profile-name blue m0">{{ user.email }}</p>
                </div>
                <div class="py2">
                  <p class="center h3n bold m0">{{ streetInfo }}</p>
                  <p v-if="user.mobilephone" class="center h3n bold m0">Tél. {{ user.mobilephone }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="flex justify-center col-12">
            <Button text="Modifier" class="center mt2 col-12 sm-col-6 md-col-4 lg-col-4" btn-color="white" :action="editProfile" />
          </div>
          <a class="h5n mt2 underline flex justify-center" @click="handleLogout">se déconnecter</a>
        </div>
      </div>
      <div class="m3 pr3 pl3 pt2 white-bg">
        <div>
          <h3>Contact en cas d'urgence</h3>
          <GenerateForm :form="formEmergencyContact" :data="emergencyContact" :save-action="submitForm" :disabled="true" />
        </div>
      </div>
      <!-- <p class="h5n pb3 semi-bold center">{{ user.email }}</p> --> <!-- Disabled for now -->
    </template>
    <router-view v-else />
  </div>
</template>

<script>

import { getCurrentInstance, computed, reactive, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import UserPhoto from '@/components/elements/UserPhoto';
import Button from '@/components/elements/Button';
import GenerateForm from '@/components/common/GenerateForm';

import { genderVocabulary, routeIsCurrentComponent, isInImpersonateModeNotification, goBack } from '@/mixins/utils';
import { updateUser } from '@/mixins/requests';

export default {
  components: {
    Button,
    UserPhoto,
    GenerateForm
  },
  setup () {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const routeMatchesComponent = () => routeIsCurrentComponent(route.name, getCurrentInstance());
    const user = computed(() => store.state.user);

    const userModel = reactive({ ...store.state.user });

    const submitForm = async () => {
      if (isInImpersonateModeNotification()) {
        return;
      }
      store.commit('setLoading', true);

      userModel.emergency_contact = emergencyContact.value;

      const user = await updateUser(userModel);

      if (user) {
        goBack(route);
      }
      store.commit('setLoading', false);
    };

    const streetInfo = computed(() => {
      let streetText = '';

      // TODO improve readability

      if (!!user.value.zip_code && !!user.value.town) {
        streetText = `${user.value.zip_code} ${user.value.town}`;
      }

      if (!!user.value.street_number && !!user.value.street_name) {
        streetText = `${user.value.street_number} ${user.value.street_name}, ${streetText}`;
      } else if (user.value.street_number) {
        streetText = `${user.value.street_number}, ${streetText}`;
      } else if (user.value.street_name) {
        streetText = `${user.value.street_name}, ${streetText}`;
      }

      return streetText;
    });

    function editProfile () {
      if (isInImpersonateModeNotification()) {
        return;
      }
      router.push({ name: 'EditMyProfile' });
    }

    const handleLogout = () => {
      store.commit('setImpersonateData', null);
      window.location.href = `/${route.params.site_preroute}/af/logout?return=${window.location.protocol}//${window.location.hostname}/${route.params.site_preroute}${route.params.site_url ? `/${route.params.site_url}` : ''}`;
    };

    const emergencyContact = ref({ 
      firstname: userModel.emergency_contact ? userModel.emergency_contact.firstname || null: null, 
      lastname: userModel.emergency_contact ? userModel.emergency_contact.lastname || null: null, 
      email: userModel.emergency_contact ? userModel.emergency_contact.email || null: null, 
      telephone: userModel.emergency_contact ? userModel.emergency_contact.telephone || null: null 
    });

    const formEmergencyContact = reactive([
      [
        { label: 'Son prénom', id: 'firstname', type: 'text', class: 'col-12 sm-col-6', required: true, placeholder: 'Prénom' },
        { label: 'Son nom', id: 'lastname', type: 'text', class: 'col-12 sm-col-6', required: true, placeholder: 'Nom' }
      ],
      [
        { label: 'Email', id: 'email', type: 'email', class: 'col-12 sm-col-6', required: true, placeholder: '' },
        { label: 'Tél. mobile', id: 'telephone', type: 'tel', class: 'col-12 sm-col-6', required: false, placeholder: '' }
      ]
    ]);

    return { emergencyContact, handleLogout, editProfile, user, streetInfo, genderVocabulary, route, routeMatchesComponent, formEmergencyContact, submitForm };
  }
};
</script>

<style>
.input-height {
  height: 50px;
}

@media (max-width: 40em) {
  .my-profile-text {
    text-align: center;
  }
}

</style>
